<template lang='pug'>
  i.svg-icon.svg-icon-messenger
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(fill="#368BCB" d="M50.75,10.009C29.271,9.585,11.496,26.62,11.005,48.098c0.056,10.934,4.897,21.294,13.249,28.352v11.394 c0,0.914,0.741,1.656,1.656,1.656c0.311,0,0.614-0.088,0.878-0.252l9.231-5.767c4.703,1.8,9.696,2.716,14.731,2.707 c21.48,0.423,39.254-16.611,39.745-38.09C90.004,26.62,72.23,9.585,50.75,10.009z")
      path(fill="#FBFBFC" d="M76.916,37.167c-0.493-0.66-1.397-0.857-2.12-0.463l-17.223,9.389l-10.714-9.187 c-0.657-0.563-1.638-0.526-2.25,0.086L24.737,56.864c-0.645,0.649-0.642,1.696,0.007,2.343c0.519,0.516,1.314,0.63,1.957,0.281 l17.223-9.391l10.724,9.191c0.658,0.563,1.638,0.525,2.249-0.086l19.873-19.873C77.349,38.746,77.411,37.825,76.916,37.167z")

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};

</script>
